import Swiper from 'swiper/dist/js/swiper.min';

if ($(".club-department-slider").length) {
    
    let mySwiper = new Swiper('.club-department-slider', {
        loop: true,
        navigation: {
            nextEl: '.club-department-slider__next',
            prevEl: '.club-department-slider__prev',
        }
    });
    
    mySwiper.on('slideChange', function () {
        departments_count(this);
    });
    
    departments_count(mySwiper);
    
    function departments_count(swiper) {
        let current = swiper.realIndex + 1,
            length = swiper.slides.length - 2;
        if (current < 10) {
            current = '0' + current;
        }
        $('.club-department-slider__counter').text(current + " / " + length);
    }

}